/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A12Inputs */

const en_pc_faq_a12 = /** @type {(inputs: Pc_Faq_A12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. github.com/PDFCraftTool/pdfcraft is a separate project by a different team: a browser-based set of PDF tools built with Next.js. This site covers the Rust desktop app from github.com/storytold/pdfcraft. The two only share a similar name.`)
};

const zh_pc_faq_a12 = /** @type {(inputs: Pc_Faq_A12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是。github.com/PDFCraftTool/pdfcraft 是另一支团队开发的独立项目，一套用 Next.js 构建的浏览器端 PDF 工具。本站介绍的是 github.com/storytold/pdfcraft 的 Rust 桌面应用。两者只是名称相近。`)
};

/**
* | output |
* | --- |
* | "No. github.com/PDFCraftTool/pdfcraft is a separate project by a different team: a browser-based set of PDF tools built with Next.js. This site covers the Rus..." |
*
* @param {Pc_Faq_A12Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a12 = /** @type {((inputs?: Pc_Faq_A12Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A12Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a12(inputs)
	return zh_pc_faq_a12(inputs)
});
export { pc_faq_a12 as "pc.faq.a12" }